<template>

    <v-dialog v-model="showDialog" v-if="condition" max-width="350">
        <v-card>
            <v-card-title class="headline">{{condition.title}}</v-card-title>
            <v-card-text>
                <div v-if="condition.action == 'fork' && condition.isForkModel"
                     style="font-size: 15px;">
                     <span class="mdi mdi-alert-outline" style="color: #FFA726; font-weight: 700; font-size:20px;"></span> You've already FORKED this model.<br>
                     Click the arrow to access the model
                     <v-btn v-if="condition.action == 'fork' && condition.isForkModel" 
                        color="primary" 
                        text small
                        @click="changedModel()">
                        <v-icon>
                            mdi-arrow-right-bold-circle-outline
                        </v-icon>
                    </v-btn>
                </div>
                <br>
                <v-text-field
                        :disabled="condition.action != 'save'"
                        v-model="condition.projectName"
                        label="Origin"
                ></v-text-field>
                <v-text-field
                        v-if="condition.action != 'save'"
                        v-model="condition.editProjectName"
                        label="projectName"
                ></v-text-field>
                <v-textarea
                        outline
                        name="input-7-4"
                        label="Comment"
                        :counter="255"
                ></v-textarea>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="close()">close</v-btn>
                <v-btn color="primary" text @click="submit()">{{submitText}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>
    export default {
        name: 'model-storage-dialog',
        components: {},
        props: {
            condition: {
                type: Object,
                default: function () {
                    return null
                }
            },
            showDialog: {
                type: Boolean,
                default: function () {
                    return false
                }
            },
            isClazzModeling:{
                type: Boolean,
                default: function () {
                    return false
                }
            }
        },
        created() {
        },
        data() {
            return {}
        },
        watch: {},
        computed: {
            submitText() {
                if (this.condition.action == 'fork') {
                    return 'FORK'
                } else {
                    return 'SAVE'
                }
            }
        },
        methods: {
            submit() {
                if (this.condition.action == 'save') {
                    this.$emit('save')
                } else if (this.condition.action == 'fork') {
                    localStorage.setItem("forkedModelInfo", JSON.stringify(this.condition.forkedModelInfo))
                    this.$emit('fork')
                } else if (this.condition.action == 'backup') {
                    this.$emit('backup')
                }
            },
            close() {
                this.$emit('close')
            },
            changedModel(){
                var me = this
                this.$emit('close')
                if(me.isClazzModeling){
                    me.$emit('updateClassModelingId',me.condition.isForkModel)
                }else{
                    me.$router.push({path: `/storming/${me.condition.userId}/${me.condition.isForkModel}`});
                    setTimeout(function () {
                        window.location.reload(true)
                    }, 100)
                }
            },

        }
        ,
    }
</script>